/* src/app/shared/common-ui/lib/waiting-indicator/waiting-indicator.component.less */
.wrapper {
  display: flex;
}
.wrapper .item {
  animation: load-anim 1.8s infinite ease-in-out;
  animation-fill-mode: both;
  background: var(--color-default-icon);
  border-radius: 50%;
}
.wrapper.medium .item {
  height: 2.3rem;
  width: 2.3rem;
}
.wrapper.medium .item.first {
  animation-delay: 0;
}
.wrapper.medium .item.second {
  margin-left: 0.5rem;
  animation-delay: 0.18s;
}
.wrapper.medium .item.third {
  margin-left: 0.5rem;
  animation-delay: 0.36s;
}
.wrapper.small .item {
  height: 1.1rem;
  width: 1.1rem;
}
.wrapper.small .item.first {
  animation-delay: 0;
}
.wrapper.small .item.second {
  margin-left: 0.35rem;
  animation-delay: 0.18s;
}
.wrapper.small .item.third {
  margin-left: 0.35rem;
  animation-delay: 0.36s;
}
.wrapper.tiny .item {
  height: 0.6rem;
  width: 0.6rem;
}
.wrapper.tiny .item.first {
  animation-delay: 0;
}
.wrapper.tiny .item.second {
  margin-left: 0.25rem;
  animation-delay: 0.18s;
}
.wrapper.tiny .item.third {
  margin-left: 0.25rem;
  animation-delay: 0.36s;
}
@-webkit-keyframes load-anim {
  40% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes load-anim {
  40% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
/*# sourceMappingURL=waiting-indicator.component.css.map */
